import React from 'react';

export const AdultsOnlyRisingPositionIcon: React.FC<React.SVGProps<SVGSVGElement>> = (props) => {
  return (
    <svg width="64" height="64" viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        d="M29.92 21.26C32.593 21.26 34.76 19.093 34.76 16.42C34.76 13.7469 32.593 11.58 29.92 11.58C27.2469 11.58 25.08 13.7469 25.08 16.42C25.08 19.093 27.2469 21.26 29.92 21.26Z"
        fill="#FF6AA0"
      />
      <path
        d="M8.34 47.98C11.0131 47.98 13.18 45.8131 13.18 43.14C13.18 40.467 11.0131 38.3 8.34 38.3C5.66694 38.3 3.5 40.467 3.5 43.14C3.5 45.8131 5.66694 47.98 8.34 47.98Z"
        fill="#00A6ED"
      />
      <path
        d="M33.8199 39.5199C32.3599 41.4399 30.8599 43.5999 30.5799 45.8599C30.4999 46.3599 30.4799 46.8399 30.5399 47.2999C25.5199 47.0199 20.9599 47.0399 15.3999 48.0599C14.7199 48.2199 14.16 47.3999 14.54 46.8199C16.9799 42.8599 21.3199 40.8199 25.6599 39.8599C28.2799 39.2399 31.0999 39.2799 33.8199 39.5199Z"
        fill="#00A6ED"
      />
      <path
        d="M60.88 48.34C55.3 47.58 50.12 47.62 44.72 47.7C44.6 47.56 44.44 47.46 44.26 47.4C42.88 46.94 41.44 46.6 40.08 46.22C41.82 44.64 43.76 42.96 44.94 40.88C50.8 41.88 56.76 43.74 61.16 47.6C61.48 47.84 61.28 48.4 60.88 48.34Z"
        fill="#00A6ED"
      />
      <path
        d="M44.92 48.62C44.86 48.88 44.68 49.08 44.46 49.2C42.78 49.96 41.06 50.5599 39.2 50.92C35.66 51.8799 30.78 50.68 31.36 46C31.84 42.84 34.54 40.26 36.28 37.8C30.58 34.28 30.36 25.58 35.12 21.12C35.38 20.86 35.86 21.04 35.88 21.4C36.96 26.28 37.08 29.72 40.82 31.24C41 31.34 44.24 32.22 44.98 35.64C45.7 40.62 41.48 43.48 38.64 46.36C40.44 46.86 42.4 47.12 44.3 47.6C44.76 47.72 45.04 48.18 44.92 48.62Z"
        fill="#FF6AA0"
      />
    </svg>
  );
};
